module.exports = __webpack_public_path__ + "editor/icon-addImage-error-a8aa508ea35c22c7566db48898eb44db.svg";